import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=1f9faab2&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"
import style0 from "./ranking.vue?vue&type=style&index=0&id=1f9faab2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9faab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9faab2')) {
      api.createRecord('1f9faab2', component.options)
    } else {
      api.reload('1f9faab2', component.options)
    }
    module.hot.accept("./ranking.vue?vue&type=template&id=1f9faab2&scoped=true", function () {
      api.rerender('1f9faab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/ranking.vue"
export default component.exports